
        import * as module0 from '../images/readwith-screenshot-list-of-books-stacked-on-shelf-desktop.jpg';import * as module1 from '../images/readwith-screenshot-list-of-books-stacked-on-shelf-mobile.jpg';import * as module2 from '../images/readwith-screenshot-reading-thread-with-person-ahead-desktop.jpg';import * as module3 from '../images/readwith-screenshot-reading-thread-with-person-ahead-mobile.jpg'
        const modules = {
            "../images/readwith-screenshot-list-of-books-stacked-on-shelf-desktop.jpg": module0,
            "../images/readwith-screenshot-list-of-books-stacked-on-shelf-mobile.jpg": module1,
            "../images/readwith-screenshot-reading-thread-with-person-ahead-desktop.jpg": module2,
            "../images/readwith-screenshot-reading-thread-with-person-ahead-mobile.jpg": module3,
        };
        export default modules;
      